module.exports = __webpack_public_path__ + "media/images/menu/scorpius-f5a5a118fa2c952b062c264001ad7eb7.jpg";